<span class="badge" [ngClass]="themeClass" data-cy="wdx-badge-item">
    <ng-content></ng-content>
</span>
